import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { merge } from 'rxjs';
import { eventFromBatch$ } from '../../../../cross-team-shared/event-tracking/event-batch-values';
import { TaskWorkspaceStore } from '../../../h3ml/state/task-workspace-store';
import { DebugLoggingService } from '../debug-logging.service';

@Component({
  selector: 'h3-start-debug-logging-modal',
  templateUrl: './start-debug-logging-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class StartDebugLoggingModalComponent {
  private debugLoggingService = inject(DebugLoggingService);
  private data: { store: TaskWorkspaceStore } = inject(MAT_DIALOG_DATA);

  startLogging() {
    const activity$ = merge(
      this.data.store('lastInteractiveEventTimestamp').$,
      eventFromBatch$,
    );

    this.debugLoggingService.startPersistentRecording(activity$);
  }
}
